import React from 'react';
import {Stack, Checkbox} from '@mui/material';
import {Body} from '@lightricks/react-design-system';
import {Option} from '@/components/dropdown-button/DropdownButton';

function FilterMenuItem({
  option,
  isSelected,
}: {
  option: Option;
  isSelected: boolean;
}) {
  return (
    <Stack direction="row" alignItems="center" justifyContent="space-between">
      <Checkbox checked={isSelected} />
      <Body size="lg">{option.label}</Body>
    </Stack>
  );
}

export default FilterMenuItem;
